import {AuthApiService} from '@spa/api';

export abstract class BasePermissionService {

    protected readonly authUserPermissions: string[];

    constructor(protected readonly authApiService: AuthApiService, ) {
        this.authUserPermissions = this.getAuthUserPermissions();
    }

    private getAuthUserPermissions() {
        return this.authApiService.getAuthenticatedUser() ? this.authApiService.getAuthenticatedUser().permissions : [];
    }
}
